import * as React from "react";
import * as ReactDOM from "react-dom";

import {FComponent} from "@Common/react/f-component";
import {isIe}       from "@Common/ui-components/debug/is-ie-edge-or-firefox";

interface P {
    next: (size: {width:number,height:number}) => JSX.Element;
}
interface S {
    size: {width:number,height:number};
}
export class ObserveDom extends FComponent<P,S> {
    constructor(props, context) {
        super(props, context);

        this.state = {
            size: null,
        };

        this.onMount(() => {
            let dom = ReactDOM.findDOMNode(this);

            const listener = () => {
                // @ts-ignore
                const rect = dom.getBoundingClientRect();
                this.setState({size: {width: rect.width, height: rect.height}});
            };
            if(!isIe())
            {
                const observe = new ResizeObserver(listener).observe(dom);
                this.onUnmount(() => new ResizeObserver(listener).unobserve(dom));
            }
            else
            {
                window.addEventListener("resize", listener);
                this.onUnmount(() => window.removeEventListener("resize", listener));
            }

            listener();
        });
    }

    render() {
        const {next} = this.props;
        const {size} = this.state;

        return next(size);
    }
}
